import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import { SquiggleActive, SquiggleHover } from './SquiggleUnderline';

// Set true when the blog is ready to show in the primary nav.
const SHOW_BLOG_IN_NAV = false;

const links = [
  { to: '/', label: 'work' },
  { to: '/bio', label: 'bio' },
  { to: '/blog', label: 'blog', matchPrefix: true },
];

const navLinks = SHOW_BLOG_IN_NAV ? links : links.filter((l) => l.to !== '/blog');

const isActive = (pathname, { to, matchPrefix }) => {
  if (matchPrefix) return pathname === to || pathname.startsWith(`${to}/`);
  return pathname === to;
};

/**
 * Primary site navigation (work / bio / blog) with squiggle underlines.
 */
export const SiteNav = ({ className }) => {
  const location = useLocation();

  return (
    <nav className={classnames('site-nav', className)} aria-label="Primary">
      {navLinks.map((item) => {
        const active = isActive(location.pathname, item);
        return (
          <Link
            key={item.to}
            to={item.to}
            className={classnames('site-nav__link', { 'site-nav__link--active': active })}
          >
            <span className="site-nav__label">{item.label}</span>
            {active ? <SquiggleActive /> : <SquiggleHover />}
          </Link>
        );
      })}
    </nav>
  );
};

export default SiteNav;
